(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9360],{

/***/ 49360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content035": function() { return /* binding */ Content035; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91929);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52853);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87367);
/* harmony import */ var _Content035_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44336);
/* harmony import */ var _Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var Content035 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2;
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    var ref3 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useToggle */ .OT)(), opened = ref3.opened, onOpen = ref3.onOpen, onClose = ref3.onClose;
    var ref4;
    var title = (ref4 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var description = (ref5 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var image = (ref6 = payload === null || payload === void 0 ? void 0 : payload.image) !== null && ref6 !== void 0 ? ref6 : {};
    var ref7;
    var requestType = (ref7 = (ref = payload.button) === null || ref === void 0 ? void 0 : ref.type) !== null && ref7 !== void 0 ? ref7 : "form";
    var _form;
    var form = (_form = payload.button.form) !== null && _form !== void 0 ? _form : {};
    var ref8;
    var buttonText = (ref8 = (ref1 = payload.button) === null || ref1 === void 0 ? void 0 : ref1.buttonText) !== null && ref8 !== void 0 ? ref8 : "";
    var ref9;
    var link = (ref9 = (ref2 = payload.button) === null || ref2 === void 0 ? void 0 : ref2.link) !== null && ref9 !== void 0 ? ref9 : "";
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_4__/* .buildWidgetInstanceId */ .G1)("035", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_5__/* .WIDGETS_REGISTRY.CONTENT */ .R.CONTENT);
    var items = [
        {
            id: "date",
            label: t("date"),
            text: payload.startDate
        },
        {
            id: "time",
            label: t("time"),
            text: payload.duration
        },
        {
            id: "price",
            label: t("price"),
            text: payload.price
        },
        {
            id: "place",
            label: t("place"),
            text: payload.format
        }, 
    ];
    var timeDescription = payload.startDate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().top),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().block),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading4 */ .k8, {
                                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headline),
                                    color: "dark",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                    value: description,
                                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().description)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().block),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .DetailsBlock */ .IR, {
                                    items: items,
                                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().course)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["button-wrap"]),
                                    children: requestType === "form" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                                        onClick: onOpen,
                                        className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                                className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().label),
                                                appearance: "bold",
                                                color: "light",
                                                uppercase: true,
                                                children: buttonText
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                                    name: "arrow_right"
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .PageLink */ .H_, {
                                        className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                        link: link,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                                className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().label),
                                                appearance: "bold",
                                                color: "light",
                                                uppercase: true,
                                                children: buttonText
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                                    name: "arrow_right"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                                    onCloseModal: onClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                        item: form,
                                        metaData: {
                                            type: "project",
                                            id: payload.id
                                        },
                                        info: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .FormInfo */ .Nf, {
                                            title: title,
                                            date: timeDescription
                                        }),
                                        instanceId: instanceId,
                                        onReset: onClose
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageLite */ .NH, {
                    image: image,
                    className: (_Content035_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content035);


/***/ }),

/***/ 44336:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content035_wrapper__5fsw2","top":"Content035_top__evCtc","block":"Content035_block__xWsiV","headline":"Content035_headline__0Dvk5","course":"Content035_course__8WiAs","description":"Content035_description__42lvB","button-wrap":"Content035_button-wrap__fhYWX","play":"Content035_play__Yc7D2","arrow":"Content035_arrow__McCqa","icon":"Content035_icon__5aypN","image":"Content035_image__ir_2l"};

/***/ })

}]);